import { createFileRoute } from "@tanstack/react-router";
import { computeSearch } from "../../features/console/compute-selection";
import { WorkspaceNew } from "../../features/workspaces/workspace-new";

export const Route = createFileRoute("/_authed/$org/$project/instances/new")({
  validateSearch: (s: Record<string, unknown>) => ({ ...(s.capacity === "spot" ? { capacity: "spot" as const } : {}), ...(typeof s.workspace === "string" ? { workspace: s.workspace } : {}), ...(typeof s.from === "string" ? { from: s.from } : {}), ...(typeof s.recover === "string" ? { recover: s.recover } : {}), ...computeSearch(s) }),
  component: NewWorkspacePage,
});

function NewWorkspacePage() {
  const { org, project } = Route.useParams();
  const { from, recover, capacity, workspace, ...compute } = Route.useSearch();
  return <WorkspaceNew capacity={capacity} initialWorkspace={workspace} mode="instance" scope={{ org, project }} compute={compute} {...(from ? { from } : {})} {...(recover ? { recover } : {})} />;
}
